import { ActivityPresentBanner } from 'approot/activity-builder/present/activity-present-banner.style';
import Text from 'approot/shared/styles/typography/text';
import {
  UnidentifiedAccessBanner,
  UnidentifiedAccessBannerContent,
} from 'approot/student-class-to-do/unidentified-access-banner.style';

type PresentAnswersBannerProps = {
  isDrawerDetailsActive: boolean;
  isAssignmentSubmitted?: boolean;
};

const PresentAnswersBanner = ({
  isDrawerDetailsActive,
  isAssignmentSubmitted,
}: PresentAnswersBannerProps) => {
  return (
    <ActivityPresentBanner $isDrawerDetailsActive={isDrawerDetailsActive}>
      <UnidentifiedAccessBanner>
        {isAssignmentSubmitted ? (
          <UnidentifiedAccessBannerContent>
            <Text>All Done! You've submitted.</Text>
          </UnidentifiedAccessBannerContent>
        ) : (
          <UnidentifiedAccessBannerContent>
            <Text>
              This slide is no longer assigned to you. You can still look at it,
              but you can't add or change your answers.
            </Text>
          </UnidentifiedAccessBannerContent>
        )}
      </UnidentifiedAccessBanner>
    </ActivityPresentBanner>
  );
};

export default PresentAnswersBanner;
